import * as THREE from 'three'
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js'
import Experience from '../index'

let points = []

export default class Point {
  constructor(lat, lng, type, id) {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.sizes = this.experience.sizes
    this.pins = this.experience.pins
    this.lat = lat
    this.lng = lng
    this.type = type
    this.id = id

    this.create3dPoint()
    this.createHtmlPoint()
  }

  create3dPoint() {
    // Bit complex math to convert latitude and longitude to 3d coordinates
    const latitude = (this.lat / 180) * Math.PI
    const longitude = (this.lng / 180) * Math.PI
    const x = Math.cos(latitude) * Math.sin(longitude)
    const y = Math.sin(latitude)
    const z = Math.cos(latitude) * Math.cos(longitude)

    // Expose coordinates for raycaster
    this.position = new THREE.Vector3(x, y, z)

    // Create a pin and add id as class
    const pin = document.createElement('div')
    pin.classList.add('point', 'point-' + points.length, 'pin--' + this.type)

    // Add pins to array for looping in src\Experience\World\index.ts
    points.push(pin)

    // Convert HTML Element to work in 3D space
    this.pinTo3d = new CSS2DObject(pin)
    this.pinTo3d.position.set(x, y, z)
    this.scene.add(this.pinTo3d)

    // Expose HTML Element for adding classes in the loop in src\Experience\World\index.ts
    this.element = pin
  }

  createHtmlPoint() {}
}
